var _rect, _g, _path, _path2, _path3, _g2, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_423_3219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3583 27.4688H16.4483C15.6484 27.4688 15 27.8067 15 28.2235V44.0742C15 44.4911 15.6484 44.829 16.4483 44.829H41.3583C42.1581 44.829 42.8065 44.4911 42.8065 44.0742V28.2235C42.8065 27.8067 42.1581 27.4688 41.3583 27.4688Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.354 30.7935H18.5681C18.0866 30.7935 17.6963 31.2033 17.6963 31.7088C17.6963 32.2144 18.0866 32.6242 18.5681 32.6242H31.354C31.8355 32.6242 32.2258 32.2144 32.2258 31.7088C32.2258 31.2033 31.8355 30.7935 31.354 30.7935Z",
    fill: "#999999",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1234 35.0659H18.5681C18.0866 35.0659 17.6963 35.4757 17.6963 35.9813C17.6963 36.4868 18.0866 36.8966 18.5681 36.8966H26.1234C26.6049 36.8966 26.9952 36.4868 26.9952 35.9813C26.9952 35.4757 26.6049 35.0659 26.1234 35.0659Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.354 39.0322H18.5681C18.0866 39.0322 17.6963 39.442 17.6963 39.9476C17.6963 40.4531 18.0866 40.8629 18.5681 40.8629H31.354C31.8355 40.8629 32.2258 40.4531 32.2258 39.9476C32.2258 39.442 31.8355 39.0322 31.354 39.0322Z",
    fill: "#999999",
    fillOpacity: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_423_3219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5238 12H16.533C15.7306 12 15.0801 12.6505 15.0801 13.453V22.1707C15.0801 22.9731 15.7306 23.6236 16.533 23.6236H41.5238C42.3263 23.6236 42.9768 22.9731 42.9768 22.1707V13.453C42.9768 12.6505 42.3263 12 41.5238 12Z",
    fill: "#999999",
    fillOpacity: 0.6
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1234 15.9482H18.5681C18.0866 15.9482 17.6963 16.3385 17.6963 16.82C17.6963 17.3015 18.0866 17.6918 18.5681 17.6918H26.1234C26.6049 17.6918 26.9952 17.3015 26.9952 16.82C26.9952 16.3385 26.6049 15.9482 26.1234 15.9482Z",
    fill: "#C9C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.354 19.7256H18.5681C18.0866 19.7256 17.6963 20.1159 17.6963 20.5974C17.6963 21.0788 18.0866 21.4691 18.5681 21.4691H31.354C31.8355 21.4691 32.2258 21.0788 32.2258 20.5974C32.2258 20.1159 31.8355 19.7256 31.354 19.7256Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_423_3219",
    x: 11.52,
    y: 22.2488,
    width: 34.7666,
    height: 24.3204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_423_3219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_423_3219",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_423_3219",
    x: 11.6001,
    y: 6.78,
    width: 34.8565,
    height: 18.5835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_423_3219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_423_3219",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFallback);
export default __webpack_public_path__ + "static/media/news-fallback.f86b5edbe6422397d08e23641397507e.svg";
export { ForwardRef as ReactComponent };